import zhcnActivityParticipation from '@/locales/zh-CN/activity_participation.js'
import zhcnAdmin from '@/locales/zh-CN/admin.js'
import zhcnAdminWithdrawApplication from '@/locales/zh-CN/admin_withdraw_application.js'
import zhcnAdvertisement from '@/locales/zh-CN/advertisement.js'
import zhcnAdvertisementClickRecord from '@/locales/zh-CN/advertisement_click_record.js'
import zhcnAdvertisingSpace from '@/locales/zh-CN/advertising_space.js'
import zhcnAlarm from '@/locales/zh-CN/alarm.js'
import zhcnAlarmNotificationRule from '@/locales/zh-CN/alarm_notification_rule.js'
import zhcnAlarmWhitelist from '@/locales/zh-CN/alarm_whitelist.js'
import zhcnAppClient from '@/locales/zh-CN/app_client.js'
import zhcnAppConfig from '@/locales/zh-CN/app_config.js'
import zhcnAppPage from '@/locales/zh-CN/app_page.js'
import zhcnBankAccount from '@/locales/zh-CN/bank_account.js'
import zhcnBillingRule from '@/locales/zh-CN/billing_rule.js'
import zhcnBillingRuleTemperatureTimer from '@/locales/zh-CN/billing_rule_temperature_timer.js'
import zhcnBillingRuleTimer from '@/locales/zh-CN/billing_rule_timer.js'
import zhcnCar from '@/locales/zh-CN/car.js'
import zhcnChargeChannel from '@/locales/zh-CN/charge_channel.js'
import zhcnChargeRecord from '@/locales/zh-CN/charge_record.js'
import zhcnChargeStation from '@/locales/zh-CN/charge_station.js'
import zhcnCharger from '@/locales/zh-CN/charger.js'
import zhcnChargingCard from '@/locales/zh-CN/charging_card.js'
import zhcnChargingCardConsumptionRecord from '@/locales/zh-CN/charging_card_consumption_record.js'
import zhcnChargingCardDefinition from '@/locales/zh-CN/charging_card_definition.js'
import zhcnChargingPackage from '@/locales/zh-CN/charging_package.js'
import zhcnChargingPackageDefinition from '@/locales/zh-CN/charging_package_definition.js'
import zhcnChargingPackageSettlement from '@/locales/zh-CN/charging_package_settlement.js'
import zhcnChargingPackageSettlementRule from '@/locales/zh-CN/charging_package_settlement_rule.js'
import zhcnCommon from '@/locales/zh-CN/common.js'
import zhcnCommonComponent from '@/locales/zh-CN/common_component.js'
import zhcnCoupon from '@/locales/zh-CN/coupon.js'
import zhcnCouponDefinition from '@/locales/zh-CN/coupon_definition.js'
import zhcnCouponRuleNew from '@/locales/zh-CN/coupon_rule_new.js'
import zhcnDashboard from '@/locales/zh-CN/dashboard.js'
import zhcnDeviceAuthenticatedResult from '@/locales/zh-CN/device_authenticated_result.js'
import zhcnDeviceOrder from '@/locales/zh-CN/device_order.js'
import zhcnDeviceTestReport from '@/locales/zh-CN/device_test_report.js'
import zhcnDiscountSettlement from '@/locales/zh-CN/discount_settlement.js'
import zhcnDiscountSettlementRule from '@/locales/zh-CN/discount_settlement_rule.js'
import zhcnEcaRule from '@/locales/zh-CN/eca_rule.js'
import zhcnEcaRuleOutcome from '@/locales/zh-CN/eca_rule_outcome.js'
import zhcnEnumeration from '@/locales/zh-CN/enumeration.js'
import zhcnEquipmentDispatch from '@/locales/zh-CN/equipment_dispatch.js'
import zhcnEquipmentProduction from '@/locales/zh-CN/equipment_production.js'
import zhcnErrorCode from '@/locales/zh-CN/error_code.js'
import zhcnErrormsg from '@/locales/zh-CN/errormsg.js'
import zhcnEvChargingGun from '@/locales/zh-CN/ev_charging_gun.js'
import zhcnEvChargingPile from '@/locales/zh-CN/ev_charging_pile.js'
import zhcnEvChargingStation from '@/locales/zh-CN/ev_charging_station.js'
import zhcnEvChargingStationDailySettlement from '@/locales/zh-CN/ev_charging_station_daily_settlement.js'
import zhcnEvChargingStationSettlement from '@/locales/zh-CN/ev_charging_station_settlement.js'
import zhcnEvcsChargeRecord from '@/locales/zh-CN/evcs_charge_record.js'
import zhcnEvcsConnector from '@/locales/zh-CN/evcs_connector.js'
import zhcnEvcsEcmpOrder from '@/locales/zh-CN/evcs_ecmp_order.js'
import zhcnEvcsEquipment from '@/locales/zh-CN/evcs_equipment.js'
import zhcnEvcsNotificationOrder from '@/locales/zh-CN/evcs_notification_order.js'
import zhcnEvcsOperator from '@/locales/zh-CN/evcs_operator.js'
import zhcnEvcsOrder from '@/locales/zh-CN/evcs_order.js'
import zhcnEvcsStation from '@/locales/zh-CN/evcs_station.js'
import zhcnEvcsTrace from '@/locales/zh-CN/evcs_trace.js'
import zhcnFeedback from '@/locales/zh-CN/feedback.js'
import zhcnGiftCardDefinition from '@/locales/zh-CN/gift_card_definition.js'
import zhcnGiftCardRedemptionRecord from '@/locales/zh-CN/gift_card_redemption_record.js'
import zhcnGiftGiving from '@/locales/zh-CN/gift_giving.js'
import zhcnGroup from '@/locales/zh-CN/group.js'
import zhcnGroupApplication from '@/locales/zh-CN/group_application.js'
import zhcnGroupTransactionRecord from '@/locales/zh-CN/group_transaction_record.js'
import zhcnHighchart from '@/locales/zh-CN/highchart.js'
import zhcnIdleFeeBill from '@/locales/zh-CN/idle_fee_bill.js'
import zhcnIdleFeeBillSettlement from '@/locales/zh-CN/idle_fee_bill_settlement.js'
import zhcnIdleFeeSettlementRule from '@/locales/zh-CN/idle_fee_settlement_rule.js'
import zhcnIdleFees from '@/locales/zh-CN/idle_fees.js'
import zhcnImgCropper from '@/locales/zh-CN/img_cropper.js'
import zhcnInsertingGunStartRecord from '@/locales/zh-CN/inserting_gun_start_record.js'
import zhcnInvoice from '@/locales/zh-CN/invoice.js'
import zhcnMagcard from '@/locales/zh-CN/magcard.js'
import zhcnMagcardSwipeRecord from '@/locales/zh-CN/magcard_swipe_record.js'
import zhcnMap from '@/locales/zh-CN/map.js'
import zhcnMaterial from '@/locales/zh-CN/material.js'
import zhcnMaterialTemplates from '@/locales/zh-CN/material_templates.js'
import zhcnMembership from '@/locales/zh-CN/membership.js'
import zhcnMenu from '@/locales/zh-CN/menu.js'
import zhcnMessage from '@/locales/zh-CN/message.js'
import zhcnModelVersionLogAudit from '@/locales/zh-CN/model_version_log_audit.js'
import zhcnModify from '@/locales/zh-CN/modify.js'
import zhcnNavigator from '@/locales/zh-CN/navigator.js'
import zhcnNewMenu from '@/locales/zh-CN/new_menu.js'
import zhcnNotification from '@/locales/zh-CN/notification.js'
import zhcnNotificationRecord from '@/locales/zh-CN/notification_record.js'
import zhcnNotificationSubscription from '@/locales/zh-CN/notification_subscription.js'
import zhcnNvrChannel from '@/locales/zh-CN/nvr_channel.js'
import zhcnOperationActivity from '@/locales/zh-CN/operation_activity.js'
import zhcnOrder from '@/locales/zh-CN/order.js'
import zhcnOrderPreSettlement from '@/locales/zh-CN/order_pre_settlement.js'
import zhcnOrderRefund from '@/locales/zh-CN/order_refund.js'
import zhcnOrderSettlement from '@/locales/zh-CN/order_settlement.js'
import zhcnOrderStatistics from '@/locales/zh-CN/order_statistics.js'
import zhcnParkingLock from '@/locales/zh-CN/parking_lock.js'
import zhcnParkingRelief from '@/locales/zh-CN/parking_relief.js'
import zhcnParkingReliefCode from '@/locales/zh-CN/parking_relief_code.js'
import zhcnParkingReliefRecord from '@/locales/zh-CN/parking_relief_record.js'
import zhcnPickupLocation from '@/locales/zh-CN/pickup_location.js'
import zhcnPointRecord from '@/locales/zh-CN/point_record.js'
import zhcnPost from '@/locales/zh-CN/post.js'
import zhcnProduct from '@/locales/zh-CN/product.js'
import zhcnProductOrder from '@/locales/zh-CN/product_order.js'
import zhcnProductReturnApplication from '@/locales/zh-CN/product_return_application.js'
import zhcnReport from '@/locales/zh-CN/report.js'
import zhcnRoadBook from '@/locales/zh-CN/road_book.js'
import zhcnRole from '@/locales/zh-CN/role.js'
import zhcnServiceProvider from '@/locales/zh-CN/service_provider.js'
import zhcnServiceProviderDailySettlement from '@/locales/zh-CN/service_provider_daily_settlement.js'
import zhcnServiceProviderTransactionRecord from '@/locales/zh-CN/service_provider_transaction_record.js'
import zhcnServiceProviderWithdrawApplicationStatistics from '@/locales/zh-CN/service_provider_withdraw_application_statistics.js'
import zhcnServiceProviderWithdrawApplication from '@/locales/zh-CN/service_provider_withdraw_application.js'
import zhcnSettlementDiscount from '@/locales/zh-CN/settlement_discount.js'
import zhcnSettlementRule from '@/locales/zh-CN/settlement_rule.js'
import zhcnSignIn from '@/locales/zh-CN/sign_in.js'
import zhcnStartAppointment from '@/locales/zh-CN/start_appointment.js'
import zhcnStationActivity from '@/locales/zh-CN/station_activity.js'
import zhcnStationComment from '@/locales/zh-CN/station_comment.js'
import zhcnStationCommentReply from '@/locales/zh-CN/station_comment_reply.js'
import zhcnStationDailySettlement from '@/locales/zh-CN/station_daily_settlement.js'
import zhcnSubscriptionTriggerRecord from '@/locales/zh-CN/subscription_trigger_record.js'
import zhcnSystemSetting from '@/locales/zh-CN/system_setting.js'
import zhcnTag from '@/locales/zh-CN/tag.js'
import zhcnTask from '@/locales/zh-CN/task.js'
import zhcnTaskDefinition from '@/locales/zh-CN/task_definition.js'
import zhcnTemperatureTimerExecution from '@/locales/zh-CN/temperature_timer_execution.js'
import zhcnThemes from '@/locales/zh-CN/themes.js'
import zhcnThirdPartyServiceTrace from '@/locales/zh-CN/third_party_service_trace.js'
import zhcnTopUp from '@/locales/zh-CN/top_up.js'
import zhcnTopUpStatistics from '@/locales/zh-CN/top_up_statistics.js'
import zhcnTransactionRecord from '@/locales/zh-CN/transaction_record.js'
import zhcnTrigger from '@/locales/zh-CN/trigger.js'
import zhcnUser from '@/locales/zh-CN/user.js'
import zhcnUserOverview from '@/locales/zh-CN/user_overview.js'
import zhcnUserStatistics from '@/locales/zh-CN/user_statistics.js'
import zhcnUsersAnalysis from '@/locales/zh-CN/users_analysis.js'
import zhcnVinBlacklist from '@/locales/zh-CN/vin_blacklist.js'
import zhcnVinRecord from '@/locales/zh-CN/vin_record.js'
import zhcnVipChargeStations from '@/locales/zh-CN/vip_charge_stations.js'
import zhcnVipMember from '@/locales/zh-CN/vip_member.js'
import zhcnVirtualUser from '@/locales/zh-CN/virtual_user.js'
import zhcnWithdrawApplication from '@/locales/zh-CN/withdraw_application.js'
import zhcnWorkOrder from '@/locales/zh-CN/work_order.js'
import zhcnChargePoint from '@/locales/zh-CN/charge_point.js'

export default {
  'zh-CN': {
    ...zhcnActivityParticipation,
    ...zhcnAdmin,
    ...zhcnAdminWithdrawApplication,
    ...zhcnAdvertisement,
    ...zhcnAdvertisementClickRecord,
    ...zhcnAdvertisingSpace,
    ...zhcnAlarm,
    ...zhcnAlarmNotificationRule,
    ...zhcnAlarmWhitelist,
    ...zhcnAppClient,
    ...zhcnAppConfig,
    ...zhcnAppPage,
    ...zhcnBankAccount,
    ...zhcnBillingRule,
    ...zhcnBillingRuleTemperatureTimer,
    ...zhcnBillingRuleTimer,
    ...zhcnCar,
    ...zhcnChargeChannel,
    ...zhcnChargeRecord,
    ...zhcnChargeStation,
    ...zhcnCharger,
    ...zhcnChargingCard,
    ...zhcnChargingCardConsumptionRecord,
    ...zhcnChargingCardDefinition,
    ...zhcnChargingPackage,
    ...zhcnChargingPackageDefinition,
    ...zhcnChargingPackageSettlement,
    ...zhcnChargingPackageSettlementRule,
    ...zhcnCommon,
    ...zhcnCommonComponent,
    ...zhcnCoupon,
    ...zhcnCouponDefinition,
    ...zhcnCouponRuleNew,
    ...zhcnDashboard,
    ...zhcnDeviceAuthenticatedResult,
    ...zhcnDeviceOrder,
    ...zhcnDeviceTestReport,
    ...zhcnDiscountSettlement,
    ...zhcnDiscountSettlementRule,
    ...zhcnEcaRule,
    ...zhcnEcaRuleOutcome,
    ...zhcnEnumeration,
    ...zhcnEquipmentDispatch,
    ...zhcnEquipmentProduction,
    ...zhcnErrorCode,
    ...zhcnErrormsg,
    ...zhcnEvChargingGun,
    ...zhcnEvChargingPile,
    ...zhcnEvChargingStation,
    ...zhcnEvChargingStationDailySettlement,
    ...zhcnEvChargingStationSettlement,
    ...zhcnEvcsChargeRecord,
    ...zhcnEvcsConnector,
    ...zhcnEvcsEcmpOrder,
    ...zhcnEvcsEquipment,
    ...zhcnEvcsNotificationOrder,
    ...zhcnEvcsOperator,
    ...zhcnEvcsOrder,
    ...zhcnEvcsStation,
    ...zhcnEvcsTrace,
    ...zhcnFeedback,
    ...zhcnGiftCardDefinition,
    ...zhcnGiftCardRedemptionRecord,
    ...zhcnGiftGiving,
    ...zhcnGroup,
    ...zhcnGroupApplication,
    ...zhcnGroupTransactionRecord,
    ...zhcnHighchart,
    ...zhcnIdleFeeBill,
    ...zhcnIdleFeeBillSettlement,
    ...zhcnIdleFeeSettlementRule,
    ...zhcnIdleFees,
    ...zhcnImgCropper,
    ...zhcnInsertingGunStartRecord,
    ...zhcnInvoice,
    ...zhcnMagcard,
    ...zhcnMagcardSwipeRecord,
    ...zhcnMap,
    ...zhcnMaterial,
    ...zhcnMaterialTemplates,
    ...zhcnMembership,
    ...zhcnMenu,
    ...zhcnMessage,
    ...zhcnModelVersionLogAudit,
    ...zhcnModify,
    ...zhcnNavigator,
    ...zhcnNewMenu,
    ...zhcnNotification,
    ...zhcnNotificationRecord,
    ...zhcnNotificationSubscription,
    ...zhcnNvrChannel,
    ...zhcnOperationActivity,
    ...zhcnOrder,
    ...zhcnOrderPreSettlement,
    ...zhcnOrderRefund,
    ...zhcnOrderSettlement,
    ...zhcnOrderStatistics,
    ...zhcnParkingLock,
    ...zhcnParkingRelief,
    ...zhcnParkingReliefCode,
    ...zhcnParkingReliefRecord,
    ...zhcnPickupLocation,
    ...zhcnPointRecord,
    ...zhcnPost,
    ...zhcnProduct,
    ...zhcnProductOrder,
    ...zhcnProductReturnApplication,
    ...zhcnReport,
    ...zhcnRoadBook,
    ...zhcnRole,
    ...zhcnServiceProvider,
    ...zhcnServiceProviderDailySettlement,
    ...zhcnServiceProviderTransactionRecord,
    ...zhcnServiceProviderWithdrawApplicationStatistics,
    ...zhcnServiceProviderWithdrawApplication,
    ...zhcnSettlementDiscount,
    ...zhcnSettlementRule,
    ...zhcnSignIn,
    ...zhcnStartAppointment,
    ...zhcnStationActivity,
    ...zhcnStationComment,
    ...zhcnStationCommentReply,
    ...zhcnStationDailySettlement,
    ...zhcnSubscriptionTriggerRecord,
    ...zhcnSystemSetting,
    ...zhcnTag,
    ...zhcnTask,
    ...zhcnTaskDefinition,
    ...zhcnTemperatureTimerExecution,
    ...zhcnThemes,
    ...zhcnThirdPartyServiceTrace,
    ...zhcnTopUp,
    ...zhcnTopUpStatistics,
    ...zhcnTransactionRecord,
    ...zhcnTrigger,
    ...zhcnUser,
    ...zhcnUserOverview,
    ...zhcnUserStatistics,
    ...zhcnUsersAnalysis,
    ...zhcnVinBlacklist,
    ...zhcnVinRecord,
    ...zhcnVipChargeStations,
    ...zhcnVipMember,
    ...zhcnVirtualUser,
    ...zhcnWithdrawApplication,
    ...zhcnWorkOrder,
    ...zhcnChargePoint
  }
}
